/* eslint-disable @nx/enforce-module-boundaries */
import { Route } from '@angular/router';
import { canActivateFn, canMatchFn } from '@kanzi-apes/kanzi-authenticator';
import { LayoutComponent } from './layout/layout.component';
import { LayoutMainViewComponent } from './components/layout-main-view/layout-main-view.component';

const kanziTitle = 'Kanzi Dashboards';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    title: kanziTitle,
    data: {
      breadcrumb: 'menu_breadcrumb.home',
    },
    canActivate: [canActivateFn],
    children: [
      {
        path: '',
        component: LayoutMainViewComponent,
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-dashboards-management').then(
            (m) => m.kanziDashboardsManagementRoutes
          ),
        title: kanziTitle + ' - Dashboards',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.dashboards',
        },
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@kanzi-apes/kanzi-authenticator').then(
        (m) => m.kanziAuthenticatorRoutes
      ),
    title: kanziTitle + ' - Login',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
